import { render, staticRenderFns } from "./layOut.vue?vue&type=template&id=6d27082c&scoped=true"
import script from "./layOut.vue?vue&type=script&lang=js"
export * from "./layOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d27082c",
  null
  
)

export default component.exports